// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__nD_VR","row":"ProcedureTreatmentSummary_row__2u0DQ"};